export default __webpack_public_path__ + "static/media/image-board-study-pyramid-n-m.230d16c4.webp";